import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import {
  AccordionWrapper,
  AccordionListTitle,
  AccordionListDesc,
  AccordionListIcon
} from './Styled';

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: 0
    };
    this.handleExpand = this.handleExpand.bind(this);
  }

  handleExpand = index => {
    const { expanded } = this.state;
    const current = expanded === index ? expanded : index;
    this.setState(() => ({ expanded: current }));
  };

  render() {
    const { data, singleView } = this.props;
    const { expanded } = this.state;
    return (
      <React.Fragment>
        {singleView ? (
          <React.Fragment>
            {data.map((item, index) => (
              <AccordionWrapper
                key={index}
                expanded={expanded === index}
                onClick={() => this.handleExpand(index)}
              >
                <AccordionListTitle expanded={expanded === index}>
                  <h6>{item.title}</h6>
                  <AccordionListIcon expanded={expanded === index} />
                </AccordionListTitle>
                {expanded === index && (
                  <AccordionListDesc>
                    <p>{item.desc}</p>
                  </AccordionListDesc>
                )}
              </AccordionWrapper>
            ))}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {data.map((item, index) => (
              <React.Fragment key={index}>
                <AccordionList {...item} singleView={singleView} index={index} />
              </React.Fragment>
            ))}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

class AccordionList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  render() {
    const { title, desc } = this.props;
    const { expanded } = this.state;
    return (
      <AccordionWrapper expanded={expanded} onClick={() => this.setState({ expanded: !expanded })}>
        <AccordionListTitle expanded={expanded}>
          <div
            css={css`
              font-size: 18px;
              font-weight: 400;
              margin-bottom: 0;
              line-height: 26px;
            `}
          >
            {title}
          </div>
          <AccordionListIcon expanded={expanded} />
        </AccordionListTitle>
        {expanded && (
          <AccordionListDesc>
            <p>{desc}</p>
          </AccordionListDesc>
        )}
      </AccordionWrapper>
    );
  }
}

Accordion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  singleView: PropTypes.bool
};

Accordion.defaultProps = {
  singleView: false
};

AccordionList.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired
};

export default Accordion;
